 <!--<printheaderview [hasimage]="1"></printheaderview>-->
<div class="row" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="margin-bottom-0px margin-top-0px font-familyhead border-bot-1px">Patient Case Record</label>
          </div>
        </div>

        <div class="row">
          <div class="col-print-10 text-align-center">
            <label class="margin-bottom-0px margin-top-0px font-familyhead"></label>
          </div>
          <!--<div class="col-print-2 padding-top-0px padding-bottom-0px">
            <qrcode class="padding-top-0px padding-bottom-0px qr-style" [qrdata]="l.FormattedCode" [size]="90" [level]="'M'"></qrcode>
          </div>-->
        </div>

        <!--<div class="col-print-12">
    <div class="row margin-left-0px">
      <div class="col-print-3">
        <label class="margin-bottom-0px font-family font-weight-normal"></label>
      </div>
      <div class="col-print-8">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-8">
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">PATIENT NAME:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal"><!--AGE(YEARS) /--> GENDER / DOB:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"><!--{{l.Age}} /--> {{l.Gender}} / {{l.DateOfBirth | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">PATIENT ID / OLD REG:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.FormattedCode}} / {{l.PatientRegistrationNumber}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">REGISTRATION DATE:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.RegistrationDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <!--<div class="row margin-left-0px">
          <div class="col-print-5">
            <label class="margin-bottom-0px font-family font-weight-normal">DATE OF BIRTH:</label>
          </div>
          <div class="col-print-7">
            <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.DateOfBirth | date:'dd-MMM-yyyy'}}</label>
          </div>
        </div>-->
              <!--<div class="row margin-left-0px">
          <div class="col-print-5">
            <label class="margin-bottom-0px font-family font-weight-normal">GENDER:</label>
          </div>
          <div class="col-print-7">
            <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Gender}}</label>
          </div>
        </div>-->
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">BIRTH IDENTITY MARKS:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.BirthIdentification1}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">BLOOD GROUP:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.BloodGroup}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">MARITAL STATUS:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.MaritalStatus}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">OCCUPATION | ORG:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Occupation}} | {{l.Institution}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">EDUCATION:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.EducationTitle}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">PRIMARY CARE GIVEN BY:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.PrimaryDoctor}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">REG.LOCATION:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.FacilityName}}</label>
                </div>
              </div>

            </div>

            <!--<div class="col-print-1">

      </div>-->

            <div class="col-print-3">
              <div class="row margin-left-0px">
                <div class="col-print-12">
                  <img class="user-image-circle-65px img250px " [src]='l.PatientImageFile' onError="this.src='dummy.jpg';">
                </div>
                <!--<div class="col-print-4">
            <qrcode [qrdata]="FormattedCode" [width]="100" [errorCorrectionLevel]="'M'"></qrcode>
          </div>-->
              </div>
              <!--<div class="row">
          <div class="col-print-12">
            <qrcode [qrdata]="FormattedCode" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
          </div>
        </div>-->
              <!--<div class="row margin-left-0px">
          <printlayout [FormattedCode]="l.FormattedCode">

          </printlayout>
        </div>-->
              <!--<div class="row margin-left-0px">
          <div class="col-print-6">
            <qrcode class="width100px" [qrdata]="l.FormattedCode" [errorCorrectionLevel]="'M'"></qrcode></div>
        </div>-->

            </div>
          </div>


        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead font-weight-normal">ADDRESS</label>
                </div>
              </div>
              <!--<div class="row margin-left-0px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family font-weight-normal">PERMANENT ADDRESS:</label>
                </div>
              </div>-->
              <div class="row margin-left-0px">
                <div class="col-print-1"></div>
                <div class="col-print-11">
                  <div class="row margin-left-0px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.AddressLine1}}</label>
                  </div>
                  <div class="row margin-left-0px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.City}}</label>
                  </div>
                  <div class="row margin-left-0px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.State}} {{l.ZipCode}}</label>
                  </div>
                  <!--<div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>-->
                </div>
              </div>
              <!--<div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal"></label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>-->
              <!--<div class="row margin-left-0px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family font-weight-normal">TEMPORARY ADDRESS:</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-12">
                  <div class="row margin-left-0px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.AddressLine1}}</label>
                  </div>
                  <div class="row margin-left-0px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.City}}</label>
                  </div>
                  <div class="row margin-left-0px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.State}} {{l.ZipCode}}</label>
                  </div>
                  
                </div>
              </div>-->



            </div>
            <div class="col-print-3">

            </div>
            <div class="col-print-4">
              <div class="row margin-left-0px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead font-weight-normal">CONTACT DETAILS</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal"><i class="fas fa-phone"></i> :</label>
                </div>
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Telephone1}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal"><i class="fas fa-envelope"></i> :</label>
                </div>
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Email}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px bordertop border-bot-1px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead font-weight-normal">REFERRAL DETAILS</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <!--<div class="col-print-5">
            <label class="margin-bottom-0px font-family font-weight-normal">REFERRED BY:</label>
          </div>-->
                <div class="col-print-1"></div>
                <div class="col-print-11">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.RefDetails}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <!--<div class="col-print-5">
    <label class="margin-bottom-0px font-family font-weight-normal">REFERRAL DETAIL:</label>
  </div>-->
                <div class="col-print-1"></div>
                <div class="col-print-11">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.RefferingDoctor}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <!--<div class="col-print-5">
    <label class="margin-bottom-0px font-family font-weight-normal">REF.CLINIC NAME:</label>
  </div>-->
                <div class="col-print-1"></div>
                <div class="col-print-11">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.RefInstitute}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <!--<div class="col-print-5">
    <label class="margin-bottom-0px font-family font-weight-normal">REF.CONTACT NO:</label>
  </div>-->
                <div class="col-print-1"></div>
                <div class="col-print-11">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.RefContactNo1}}</label>
                </div>
              </div>

            </div>
            <div class="col-print-1">

            </div>
            <div class="col-print-5">

            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">CREATED BY:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.CreatedUserName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">VERIFIED BY:</label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal"></label>
                </div>
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-bold">(</label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family font-weight-bold">)</label>
                </div>
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
            </div>
            <div class="col-print-1">

            </div>
            <div class="col-print-5">

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>
<!--<printcaserecfooterview></printcaserecfooterview>-->

<div class="">
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
  </div>
  <div class="col-print-12">
    <div class="card">

      <div class="card-header border-bottom-0px">

      </div>
      <div class="card-body padding-top-0px padding-bottom-0px">


        <div class="row" *ngIf="DoctorDetailsData">
          <div class="col-print-12 text-align-right">
            <label class="margin-bottom-0px font-familysubhead text-align-center">{{DoctorDetailsData.SignAuthority}}</label>
          </div>
        </div>
        <div class="row text-align-center" *ngIf="DoctorDetailsData">
          <div class="col-print-12 text-align-right">
            <label class="margin-bottom-0px font-family text-align-center">{{DoctorDetailsData.Line1}}</label>
          </div>
        </div>
        <div class="row text-align-center" *ngIf="DoctorDetailsData">
          <div class="col-print-12 text-align-right">
            <label class="margin-bottom-0px font-family text-align-center">{{DoctorDetailsData.Line2}}</label>
          </div>
        </div>


      </div>


      <!--<div class="row">
      <div class="col-md-4">
        <label class="margin-bottom-0px font-family">Print Taken On:</label>
      </div>
      <div class="col-md-6">
        <label class="margin-bottom-0px font-family float-left">{{Date | date:'dd-MMM-yyyy'}}</label>
      </div>
    </div>-->
    </div>
  </div>
</div>


<!--<div *ngIf="SelectedPatientFormattedCode" class="margin-top-10">
  <div class="card">
    <printlayout [FormattedCode]="SelectedPatientFormattedCode.FormattedCode">

    </printlayout>
  </div>
</div>-->




